import Trigger from '../../../lib/trigger';
export default Trigger;
